import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Card, CardContent } from '../ui/card';
import { Heart, Shield, Smile, Eye, Calendar } from 'lucide-react';

// Benefits — matching the official ozarkmtnco.com /employment/ list.
const BENEFITS = [
  { icon: Calendar, title: 'Simple IRA' },
  { icon: Heart, title: 'Health Insurance' },
  { icon: Smile, title: 'Dental Insurance' },
  { icon: Shield, title: 'Life Insurance' },
  { icon: Eye, title: 'Vacation Pay' },
];

export default function CareersBenefits() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section
      className="py-16 sm:py-20 bg-background border-t border-bone-2"
      data-testid="careers-benefits"
      ref={ref}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="mb-10 max-w-2xl"
        >
          <p className="kicker mb-3">Benefits</p>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-foreground mb-4">
            Full-time benefits package.
          </h2>
          <p className="text-foreground/75 leading-relaxed">
            Benefits for full-time employees include the following.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3"
        >
          {BENEFITS.map((benefit) => {
            const Icon = benefit.icon;
            return (
              <Card
                key={benefit.title}
                className="relative overflow-hidden hover:shadow-md transition-[box-shadow] duration-300"
                data-testid={`careers-benefit-${benefit.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="spec-strip" />
                <CardContent className="p-5 pt-7 flex flex-col items-start">
                  <Icon className="w-5 h-5 text-primary mb-3" />
                  <p className="font-display font-semibold text-sm text-foreground leading-tight">
                    {benefit.title}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
